<script>
// import storageService from "@/services/storage.service";
import Layout from "../../layouts/main";
import { pieChart } from "./data-apex";
import EasyDataTable from "vue3-easy-data-table";
import "vue3-easy-data-table/dist/style.css";
import axios from 'axios';
import statusOptionsMixin from "@/mixins/statusOptions";
import serverTableMixin from "@/mixins/serverTable";

import AppIcon from "@/components/shared/AppIcon.vue";
import EcuSelect from "@/components/shared/EcuSelect.vue";
import StatusChip from "@/components/shared/StatusChip.vue";
import TableFooter from "@/components/shared/TableFooter.vue";

import { formatDate } from "@/helpers/dateFormatter";

export default {
  mixins: [statusOptionsMixin, serverTableMixin],
  components: {
    Layout,
    EasyDataTable,
    AppIcon,
    EcuSelect,
    StatusChip,
    TableFooter,
  },
  data() {
    return {
      verifyOpen: false, // confirmation before the verified switch changes
      pendingVerify: null,
      assignPrsn: 'Default AssignPrsn', // Default value of assignPrsn
      assignPrsn2: [], // Your array of options
      selectedOption: '', // Selected option (initially set to assignPrsn)
      pieChart: pieChart,
      searchValueTable: "",
      selectFilterSort: null,
      sortFieldMap: {
        applicantId: "id",
        applicantName: "name",
        logdate: "created_on",
        statusLog: "status",
      },
      headers: [
        { text: "#ApplicantId", value: "applicantId", sortable: true },        
        { text: "Applicant Name", value: "applicantName", sortable: true },
        { text: "Assign", value: "assignPrsn" },
        { text: "Date", value: "logdate", sortable: true },
        { text: "Status", value: "statusLog", sortable: true },
        { text: "Action", value: "actionBtn" },
        { text: "Is Verified", value: "toggleBtn" },
      ],
      items: [],
      arrItem: [],
    };
  },
  computed: {
    statusSelectOptions() {
      return [
        { value: null, label: "All Status" },
        ...this.statusFilterOptions.map((o) => ({ value: o.key, label: o.label })),
      ];
    },
  },
  mounted() {
    this.loadTable();
  },
  methods: {
    // footer controls -> the server-side table options (the mixin reloads on change)
    onPageChange(page) {
      this.serverOptions = { ...this.serverOptions, page };
    },
    onRowsChange(rowsPerPage) {
      this.serverOptions = { ...this.serverOptions, rowsPerPage, page: 1 };
    },
    // staff the application can be handed to (everyone except the current assignee)
    assignOptions(current, staffList, appId) {
      return (staffList || [])
        .filter(
          (o) => current !== `${o.first_name || ""} ${o.last_name || ""}`.trim(),
        )
        .map((o) => ({
          value: `${o.id}/${appId}`,
          label:
            `${o.first_name || ""} ${o.last_name || ""}`.trim() || o.username,
        }));
    },
    updateAssignPrsn(event) {
      const selectedValue = event ? event.target.value : "";
      if (!selectedValue) return;
      axios
        .post(`/applications/change_staff/`, {
          app_data: selectedValue,
        })
        .then(() => {
          const parts = selectedValue.split("/");
          if (parts.length === 2) {
            const staffId = parseInt(parts[0]);
            const targetAppId = parseInt(parts[1]);
            const targetRow = this.arrItem.find(
              (item) => item.applicantId === targetAppId
            );
            if (targetRow && targetRow.assignPrsn2) {
              const staff = targetRow.assignPrsn2.find((s) => s.id === staffId);
              if (staff) {
                const staffName =
                  `${staff.first_name || ""} ${staff.last_name || ""}`.trim() ||
                  staff.username;
                targetRow.assignPrsn = staffName;
              }
            }
          }
        })
        .catch((error) => {
          console.error("Error changing staff:", error);
        });
    },
    requestTable(params) {
      return axios.get("/applications/all_application_details/", { params });
    },
    applyTable(data) {
      this.arrItem = (data.results || []).map((item) => {
        const secName = item.section_a1
          ? `${item.section_a1.first_name || ""} ${item.section_a1.sur_name || ""}`.trim()
          : "";
        const appName = item.applicant_name
          ? item.applicant_name
          : item.applicant
          ? `${item.applicant.first_name || ""} ${item.applicant.last_name || ""}`.trim() || item.applicant.username
          : "";
        const formattedDate = formatDate(item.created_on || item.created_at);
        return {
          applicantId: item.id,
          applicantName: secName || appName || "N/A",
          assignPrsn: item.rev || "N/A",
          assignPrsn2: item.rev2 || [],
          assignPrsn3: item.id,
          logdate: formattedDate,
          dateLog: formattedDate,
          statusLog: item.status,
          actionBtnUrl: `/single_applicant/${item.id}`,
          toggleBtnUrl: `${item.id}`,
        };
      });
    },
    toggleCheckbox(toggleBtnUrl, event) {
      // ask first: the switch only changes after the admin confirms
      const verify = !!(event && event.target && event.target.checked);
      if (event) event.preventDefault();
      this.pendingVerify = { id: parseInt(toggleBtnUrl), verify };
      this.verifyOpen = true;
    },
    confirmVerify() {
      const pending = this.pendingVerify;
      this.verifyOpen = false;
      this.pendingVerify = null;
      if (!pending) return;
      axios
        .post("/applications/toggle_verify/", { aid: pending.id, verifyit: pending.verify })
        .then((response) => {
          if (response.data.status === "SUCCESS") {
            // the status filter / page contents depend on the new status
            this.loadTable(true);
          }
        })
        .catch((error) => {
          window.alert(
            (error.response && error.response.data && error.response.data.error) ||
              "Could not update the verification status.",
          );
        });
    },
  },
  
};
</script>

<template>
  <Layout>
    <section class="apps">
      <!-- Heading (left) + search / filter (right), on one line -->
      <header class="ecu-page-head apps__head">
        <div>
          <h1>All Applications</h1>
          <p class="ecu-page-head__sub">Review, assign and verify membership applications.</p>
        </div>

        <div class="apps__tools">
          <div class="ecu-field ecu-field--search">
            <AppIcon name="search" :size="18" />
            <input
              type="text"
              v-model="searchValueTable"
              @input="onSearchInput"
              placeholder="Search applicant..."
              aria-label="Search applicant"
            />
            <button
              v-if="searchValueTable"
              type="button"
              class="search__clear"
              aria-label="Clear search"
              @click="clearSearch"
            >
              <AppIcon name="x" :size="14" :stroke="2.4" />
            </button>
          </div>

          <EcuSelect
            v-model="selectFilterSort"
            class="ecu-filter-select"
            :options="statusSelectOptions"
            aria-label="Filter by status"
            @change="onStatusChange"
          />
        </div>
      </header>

      <div class="ecu-card">
        <div class="ecu-table-wrap apps__table">
          <EasyDataTable
            header-text-direction="center"
            :headers="headers"
            :items="arrItem"
            v-model:server-options="serverOptions"
            :server-items-length="totalItems"
            :loading="tableLoading"
            :rows-items="[10, 20, 50, 100]"
            empty-message="No applications found"
            theme-color="#f97316"
            hide-footer
            show-index
            table-class-name="table-custom-style noWrapHeading"
          >
            <template #item-statusLog="{ statusLog }">
              <StatusChip :status="statusLog" />
            </template>
            <template #item-assignPrsn="{ assignPrsn, assignPrsn2, assignPrsn3 }">
              <EcuSelect
                :key="assignPrsn"
                size="sm"
                class="ecu-assign-select"
                :placeholder="assignPrsn"
                :options="assignOptions(assignPrsn, assignPrsn2, assignPrsn3)"
                aria-label="Assign staff"
                @change="updateAssignPrsn({ target: { value: $event } })"
              />
            </template>
            <template #item-logdate="{ logdate, dateLog }">
              <span class="ecu-date">
                <AppIcon name="calendar" :size="16" />
                {{ logdate || dateLog }}
              </span>
            </template>
            <template #item-actionBtn="{ actionBtnUrl }">
              <router-link :to="`${actionBtnUrl}`" class="ecu-btn-view">
                <AppIcon name="eye" :size="16" />
                View
              </router-link>
            </template>
            <template #item-toggleBtn="{ toggleBtnUrl, statusLog }">
              <label class="ecu-switch">
                <input
                  type="checkbox"
                  :checked="statusLog === 'approved'"
                  :disabled="!['verified', 'approved'].includes(statusLog)"
                  @click="toggleCheckbox(toggleBtnUrl, $event)"
                />
                <span class="ecu-switch__slider"></span>
              </label>
            </template>
          </EasyDataTable>
        </div>

        <TableFooter
          :page="serverOptions.page"
          :rows-per-page="serverOptions.rowsPerPage"
          :total="totalItems"
          :loading="tableLoading"
          @update:page="onPageChange"
          @update:rowsPerPage="onRowsChange"
        />
      </div>

      <!-- confirmation before an application is verified / un-verified -->
      <b-modal
        title="Confirm Verification"
        v-model="verifyOpen"
        hide-footer
        centered
      >
        <div class="ecu-m-confirm">
          <span class="ecu-m-confirm__icon"><AppIcon name="alert" :size="28" /></span>
          <h5 v-if="pendingVerify && pendingVerify.verify">
            Do you really want to mark this<br />application as verified?
          </h5>
          <h5 v-else>
            Do you really want to move this<br />application back to In Review?
          </h5>
          <div class="ecu-m-actions ecu-m-actions--center">
            <button class="ecu-m-btn ecu-m-btn--ghost" type="button" @click="verifyOpen = false">
              No
            </button>
            <button class="ecu-m-btn" type="button" @click="confirmVerify">Yes</button>
          </div>
        </div>
      </b-modal>
    </section>
  </Layout>
</template>

<style scoped>
.ecu-toolbar__row .ecu-field--search input {
  padding-right: 40px;
}
.apps__tools .ecu-field--search input {
  padding-right: 40px;
}
.search__clear {
  position: absolute;
  right: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: #5f6579;
  cursor: pointer;
}
.search__clear:hover {
  color: #e84d00;
}
.apps {
  display: flex;
  flex-direction: column;
  gap: 22px;
}
.apps .ecu-page-head {
  margin-bottom: 0;
}
/* heading on the left, search + filter on the right, vertically aligned */
.apps__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
}
.apps__tools {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  margin-left: auto;
}
.apps__tools .ecu-field--search {
  position: relative;
  min-width: 260px;
}
.apps .ecu-card {
  padding: 22px 22px 18px;
}
.apps .ecu-assign-select {
  min-width: 180px;
}
.apps .ecu-toolbar .ecu-tile {
  background: transparent;
}
@media (max-width: 767px) {
  .apps .ecu-card {
    padding: 16px 14px 14px;
  }
  .apps__tools {
    width: 100%;
    margin-left: 0;
    flex-wrap: wrap;
  }
  .apps__tools .ecu-field--search {
    flex: 1 1 100%;
    min-width: 0;
  }
}
</style>